/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TravelDateRange
 */
export interface TravelDateRange {
    /**
     * 
     * @type {object}
     * @memberof TravelDateRange
     */
    from?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TravelDateRange
     */
    to?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof TravelDateRange
     */
    exclude?: boolean;
}

export function TravelDateRangeFromJSON(json: any): TravelDateRange {
    return TravelDateRangeFromJSONTyped(json, false);
}

export function TravelDateRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelDateRange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function TravelDateRangeToJSON(value?: TravelDateRange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'to': value.to,
        'exclude': value.exclude,
    };
}


